import { Component, input, signal } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { RubricService } from '../../../../services/rubric.service';
import { DropdownControl } from '../../../controls/setup-wizard/dropdown-control/dropdown-control';

@Component({
	selector: 'app-rubric-code-dropdown-field',
	imports: [DropdownControl],
	standalone: true,
	templateUrl: './rubric-code-dropdown-field.html',
	styleUrl: './rubric-code-dropdown-field.scss',
})
export class RubricCodeDropdownField {
	label = input.required<string>();
	controlName = input.required<string>();
	placeholder = input<string>('');
	required = input<boolean>(true);
	formGroup = input.required<FormGroup>();
	options = signal<{ value: string; label: string }[]>([]);

	constructor(private rubricService: RubricService) {
		this.rubricService.getRubrics$().then(rubrics => {
			this.options.set(rubrics.map(rubric => ({ value: rubric.code, label: rubric.code })));
		});
	}
}
